module.exports = "\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/depart-enquiry/complaint-reg-sanction/complaint-reg-sanction-form/complaint-reg-sanction-form.component.css
// module id = ./src/app/hrms/depart-enquiry/complaint-reg-sanction/complaint-reg-sanction-form/complaint-reg-sanction-form.component.css
// module chunks = main